import { render, staticRenderFns } from "./AccessRightsList.vue?vue&type=template&id=25e1c6f6"
import script from "./AccessRightsList.vue?vue&type=script&lang=js"
export * from "./AccessRightsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports